import React, { useContext } from 'react';
import styles from './RecordCompareRecordObject.module.scss';
import { Column } from '../Layout/RecordCompareLayout';
import I18n from '../../../I18n/I18n/I18n';
import useRecordLabel from '../../hooks/useRecordCompareLabel';
import FileDownload from './RecordCompareFileDownload';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import PropertyTitle from './RecordComparePropertyTitle';
export default function StaticTextColumn(_ref) {
  var recordIndex = _ref.recordIndex,
    property = _ref.property;
  var _useRecordLabel = useRecordLabel(recordIndex, property),
    label = _useRecordLabel.label,
    isEmpty = _useRecordLabel.isEmpty,
    uri = _useRecordLabel.uri,
    escape = _useRecordLabel.escape;
  var _useContext = useContext(RecordCompareStateContext),
    isMergeEnabled = _useContext.isMergeEnabled,
    cardView = _useContext.cardView;
  return /*#__PURE__*/React.createElement(Column, {
    className: "".concat(isEmpty ? styles['empty'] : '', " ").concat(isMergeEnabled ? styles['read-only'] : styles['merge-disabled'])
  }, cardView ? /*#__PURE__*/React.createElement(PropertyTitle, {
    property: property
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: !cardView && styles.span,
    tabIndex: 0
  }, cardView ? /*#__PURE__*/React.createElement("a", {
    href: uri,
    className: styles.download
  }, label, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, ' ', /*#__PURE__*/React.createElement(I18n, {
    i18n: label
  }))) : /*#__PURE__*/React.createElement(I18n, {
    i18n: label,
    escape: escape
  })), !cardView ? /*#__PURE__*/React.createElement(FileDownload, {
    uri: uri,
    label: label
  }) : null);
}